import { withStyles } from '@material-ui/core/styles';
import { ButtonGroup } from '@material-ui/core';
import hex2Rgba from './hex2Rgba'

const ContrastButtonGroup = withStyles((theme) => ({
    grouped: {
      '&:not(:last-child)': {
      borderRight: `1px solid ${hex2Rgba(theme.palette.getContrastText(theme.palette.primary.main), 0.4)}`,
    }},
  }))(ButtonGroup)

export default ContrastButtonGroup